import {
    createTextHeader,
    TextHeader,
} from '@vfde-brix/ws10/text-header';
import {
    goToBasket,
    selectHardwareOnly,
    selectHasError,
    selectSimOnly,
} from '../container/App/slice';
import {
    createStructuredAppSelector,
    selectDeviceModelName,
    selectMonthlyPrice,
    selectOneTimePrice,
    selectTariffName,
} from '../container/App/selectors';
import { startAppListening } from '../container/App/listener';
import { useDispatch } from '../store';
import { ADDITIONAL_PAGE_OPTIONS } from '@vfde-sails/constants';
import { PriceType } from '@vfde-sails/glados-v2';
import { Price } from '@vfde-brix/ws10/core';

/**
 * Mount text header
 */
export default function mountTextHeader (id: string): TextHeader | null {
    const dispatch = useDispatch();

    const container = document.getElementById(id);

    const textHeader = container && createTextHeader(container, {
        onClick: (event: Event) => {
            event.preventDefault();
            dispatch(goToBasket());
        },
    });

    const selectTextHeaderState = createStructuredAppSelector({
        isHardwareOnly: selectHardwareOnly,
        isSimOnly: selectSimOnly,
        deviceName: selectDeviceModelName,
        tariffName: selectTariffName,
        monthlyPrice: selectMonthlyPrice,
        oneTimePrice: selectOneTimePrice,
    });

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectTextHeaderState(currentState) !== selectTextHeaderState(previousState),
        effect: (_action, api) => {
            api.cancelActiveListeners();

            const state = selectTextHeaderState(api.getState());
            const { priceLabel, headline: headlineFromCms } = window[ADDITIONAL_PAGE_OPTIONS].textHeader;

            const prices = [];

            if (state.monthlyPrice) {
                // Inject monthly price at first position
                prices.push({
                    label: priceLabel[PriceType.Monthly],
                    price: Price.fromString(state.monthlyPrice.toFixed(2)),
                });
            }

            if (state.oneTimePrice) {
                prices.push({
                    label: priceLabel[PriceType.Onetime],
                    price: Price.fromString(state.oneTimePrice.toFixed(2)),
                });
            }

            textHeader?.update({
                ...state.isHardwareOnly && { stdHeadline: headlineFromCms.hardwareOnly },
                ...state.isSimOnly && { stdHeadline: headlineFromCms.simOnly },
                stdSubline: state.deviceName ?? state.tariffName ?? undefined,
                stdPrice: prices,
            });
        },
    });

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectHasError(currentState) !== selectHasError(previousState),
        effect: (_action, api) => {
            api.cancelActiveListeners();

            textHeader?.update({
                button: {
                    // eslint-disable-next-line max-len
                    ...textHeader.getProperties().button!, // Needs to be in here, because nested properties don't support the partial update
                    optDisabled: selectHasError(api.getState()),
                },
            });
        },
    });

    return textHeader;
}
